import { request } from "utils/request";
import { AxiosPromise } from "axios";

export const productPropertyApi = {
  findAll: (params?: any): AxiosPromise<any> =>
    request({
      url: "/v1/shop/productProperty",
      params,
    }),
  create: (data: any): AxiosPromise<any> =>
    request({
      url: "/v1/shop/productProperty",
      data,
      method: "post",
    }),
  update: (id: number, data: any): AxiosPromise<any> =>
    request({
      url: `/v1/shop/productProperty/${id}`,
      method: "patch",
      data,
    }),
  delete: (id: number): AxiosPromise<any> =>
    request({
      url: `/v1/shop/productProperty/${id}`,
      method: "delete",
    }),
};
